module.exports = __webpack_public_path__ + "img/icon4.15aad8ce.svg";